import { render, staticRenderFns } from "./applyForm.vue?vue&type=template&id=04990c0b&scoped=true&"
import script from "./applyForm.vue?vue&type=script&lang=js&"
export * from "./applyForm.vue?vue&type=script&lang=js&"
import style0 from "./applyForm.vue?vue&type=style&index=0&id=04990c0b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04990c0b",
  null
  
)

export default component.exports